module.exports = __webpack_public_path__ + "static/media/settings.7b4aaacc.svg";